export default __webpack_public_path__ + "static/media/launchSaLogo.daa1d237.png";